module.exports = __webpack_public_path__ + "assets/ed5e37f860e6fd214d07e57af3db0104.mp3";